// =============================================
// Syfte-alternativ för Briefs-modulen
// =============================================

// Huvudsyfte (single-select)
export const PRIMARY_OBJECTIVES = [
  { id: 'sales_short', label: 'Driva försäljning (kort sikt)', description: 'Fokus på pris, erbjudande, volym, kampanj' },
  { id: 'distribution', label: 'Öka distribution / listning', description: 'Stöd till kedja, ny listning, sortimentsbredd' },
  { id: 'brand', label: 'Stärka varumärket', description: 'Långsiktig kännedom, image, igenkänning' },
  { id: 'launch', label: 'Lansera produkt eller nyhet', description: 'Ny produkt, nytt format, uppdaterad förpackning' },
  { id: 'position', label: 'Positionera produkt', description: 'Premium, vardag, foodservice, ursprung, funktion' },
  { id: 'season', label: 'Aktivera säsong eller tillfälle', description: 'Påsk, grill, jul, sommar etc.' },
  { id: 'sales_support', label: 'Stötta säljorganisation / kunddialog', description: 'Underlag för möten, presentationer, offerter' },
];

// Delmål (multi-select)
export const SECONDARY_OBJECTIVES = [
  { id: 'awareness', label: 'Öka kännedom om produkten' },
  { id: 'inspiration', label: 'Skapa inspiration och användningsidéer' },
  { id: 'versatility', label: 'Tydliggöra användningsområden / mångsidighet' },
  { id: 'traffic', label: 'Driva trafik (till butik, kedja, webb)' },
  { id: 'usp', label: 'Förklara skillnad / USP' },
  { id: 'premium', label: 'Förstärka premium- eller kvalitetsintryck' },
  { id: 'simplify', label: 'Förenkla val i butik' },
  { id: 'origin', label: 'Bygga trovärdighet kring ursprung och råvara' },
  { id: 'campaign_support', label: 'Stötta kampanj i butik' },
  { id: 'professional', label: 'Stötta kommunikation mot professionella kök' },
];

// Säsong (multi-select)
export const SEASONS = [
  { id: 'spring', label: 'Vår' },
  { id: 'summer', label: 'Sommar' },
  { id: 'autumn', label: 'Höst' },
  { id: 'winter', label: 'Vinter' },
  { id: 'evergreen', label: 'Helår / Evergreen' },
];

// Säsongs- och tillfällesteman (multi-select)
export const SEASONAL_THEMES = [
  { id: 'grill', label: 'Grillsäsong' },
  { id: 'easter', label: 'Påsk' },
  { id: 'midsummer', label: 'Midsommar' },
  { id: 'harvest', label: 'Skördetid' },
  { id: 'autumn_cozy', label: 'Höstmys' },
  { id: 'christmas', label: 'Jul' },
  { id: 'newyear', label: 'Nyår' },
  { id: 'sports', label: 'Sport & evenemang' },
  { id: 'everyday', label: 'Vardagsmat' },
  { id: 'party', label: 'Fest & helg' },
  { id: 'picnic', label: 'Picknick / utomhus' },
  { id: 'graduation', label: 'Student / examen' },
];

// Kommersiell kontext (multi-select)
export const COMMERCIAL_CONTEXTS = [
  { id: 'campaign', label: 'Kampanjperiod' },
  { id: 'launch_period', label: 'Lanseringsperiod' },
  { id: 'sales_period', label: 'Säljperiod' },
  { id: 'inspiration_period', label: 'Inspirationsperiod' },
  { id: 'pre_listing', label: 'Inför listning' },
  { id: 'post_launch', label: 'Efter lansering / påminnelse' },
];
